import { rootApi } from './baseApi';

export interface BaseUnitAlarmRecipient {
  id?: number;
  user_id: number;
  notify_email: boolean;
  notify_sms: boolean;
  first_name?: string;
  last_name?: string;
  email?: string;
  mobile_number?: string;
}

export interface BaseUnitAlarmConfig {
  id: number;
  base_unit_serial: string;
  disconnected_enabled: boolean;
  disconnected_delay_mins: number;
  power_alarm_enabled: boolean;
  repeat_enabled: boolean;
  repeat_interval_mins: number;
}

export interface BaseUnitAlarmConfigResponse {
  config: BaseUnitAlarmConfig | null;
  recipients: BaseUnitAlarmRecipient[];
}

export interface UpsertBaseUnitAlarmConfigRequest {
  serial: string;
  disconnected_enabled: boolean;
  disconnected_delay_mins: number;
  power_alarm_enabled: boolean;
  repeat_enabled: boolean;
  repeat_interval_mins: number;
  recipients: { user_id: number; notify_email: boolean; notify_sms: boolean }[];
}

export const baseUnitAlarmApi = rootApi.injectEndpoints({
  endpoints: (builder) => ({
    getBaseUnitAlarmConfig: builder.query<BaseUnitAlarmConfigResponse, string>({
      query: (serial) => ({ url: `/base-unit-alarms/${serial}`, method: 'GET' }),
      providesTags: (_result, _err, serial) => [{ type: 'BaseUnitAlarm', id: serial }],
    }),

    upsertBaseUnitAlarmConfig: builder.mutation<{ ok: boolean; configId: number }, UpsertBaseUnitAlarmConfigRequest>({
      query: ({ serial, ...body }) => ({
        url: `/base-unit-alarms/${serial}`,
        method: 'PUT',
        body,
      }),
      invalidatesTags: (_result, _err, { serial }) => [{ type: 'BaseUnitAlarm', id: serial }],
    }),
  }),
});

export const {
  useGetBaseUnitAlarmConfigQuery,
  useUpsertBaseUnitAlarmConfigMutation,
} = baseUnitAlarmApi;
